module.exports = __webpack_public_path__ + "img/home-catfood.a27b00c3.jpg";